import type { GetBillingAccountResponseSubscriptionDto } from 'app/API';

export const getActiveFreeTrialSubscription = (
  subscriptions: GetBillingAccountResponseSubscriptionDto[],
  now: Date,
): GetBillingAccountResponseSubscriptionDto | undefined =>
  subscriptions.find(
    (subscription) =>
      subscription.status === 'trialing' &&
      !subscription.cancelAt &&
      !!subscription.freeTrialEndDate &&
      new Date(subscription.freeTrialEndDate).getTime() > now.getTime(),
  );
